import DataMapper from './DataMapper'
import PolicyTypeRM from '../responsemodel/PolicyTypeRM'
import PolicyType from '../../models/PolicyType'

export default class PolicyTypeDataMapper extends DataMapper<PolicyTypeRM, PolicyType> {
  map = (rm: PolicyTypeRM) => new PolicyType(rm.id, rm.title, rm.description)
}
